import apiManager from './apiManager'
const listCustomerInformation = async (pageNumber = 1) => {
	const customerInformation = apiManager.axios
		.get(`v1/admin/client?${pageNumber}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return customerInformation
}
const getSingleCustomerInformation = async (id) => {
	const singleCustomer = apiManager.axios
		.get(`v1/admin/client/${id}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return singleCustomer
}

const updateCustomerProfile = async (id, updateObj, file) => {
	const formData = new FormData()
	apiManager.axios.defaults.timeout = 20000
	apiManager.axios.defaults.headers.post['Content-Type'] =
		'multipart/form-data'
	formData.append('name', updateObj.name)
	formData.append('email', updateObj.email)
	formData.append('phone', updateObj.phone.replace(/\s+/g, ''))
	formData.append('pictureUrl', file)
	const updateCustomer = apiManager.axios
		.patch(`/v1/admin/client/${id}`, formData)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return updateCustomer
}
const getCustomerDemandList = async (pageNumber = 1) => {
	const customerDemandList = apiManager.axios
		.get(`v1/admin/demand?page=${pageNumber}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return customerDemandList
}
const deleteDemand = async (id) => {
	const delDemand = apiManager.axios
		.delete(`v1/admin/demand/${id}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return delDemand
}
const deleteCustomer = async (id) => {
	const delCustomer = apiManager.axios
		.delete(`/v1/admin/client/${id}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return delCustomer
}
export default {
	listCustomerInformation,
	getSingleCustomerInformation,
	updateCustomerProfile,
	getCustomerDemandList,
	deleteDemand,
	deleteCustomer,
}
